import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import * as serviceWorker from './serviceWorker'

import { runWithAdal } from 'react-adal'
import { authContext } from './utils/AdalConfig'
import { getUrlVars } from './utils/UrlUtils'

if (getUrlVars()["mode"]) {
    ReactDOM.render(<App />, document.getElementById('root'))
} else {
    runWithAdal(
        authContext,
        () => {
            ReactDOM.render(<App />, document.getElementById('root'))
        },
        false
    )
}


//ReactDOM.render(<App />, document.getElementById('root'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()
